'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _EventHandler = require('../utils/EventHandler');

var _EventHandler2 = _interopRequireDefault(_EventHandler);

var _imagesloaded = require('imagesloaded');

var _imagesloaded2 = _interopRequireDefault(_imagesloaded);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RTE = function () {
  function RTE(el) {
    var _this = this;

    (0, _classCallCheck3.default)(this, RTE);

    this.el = el;
    this.ev = new _EventHandler2.default();

    this.setupTabs();
    this.setupImages();
    this.setupVideos(this.el);

    this.ev.register(window, 'resize', function () {
      return _this.setupVideos();
    });
    this.el.querySelectorAll('.tabs li').forEach(function (el) {
      _this.ev.register(el, 'click', _this.switchTabs.bind(_this));
    });
  }

  (0, _createClass3.default)(RTE, [{
    key: 'setupImages',
    value: function setupImages() {
      var images = this.el.querySelectorAll('p > img');
      return (0, _imagesloaded2.default)(images, function () {
        images.forEach(function (img) {
          var wrapper = document.createElement('div');
          wrapper.className = 'image-wrap';
          wrapper.style = img.getAttribute('style');
          img.parentNode.insertBefore(wrapper, img);
          wrapper.appendChild(img);
        });
      });
    }
  }, {
    key: 'setupVideos',
    value: function setupVideos(root) {
      if (!root) {
        return;
      }
      if (root.classList.contains('special')) {
        return;
      }
      var videos = root.querySelectorAll('iframe, embed, object');
      var contentWidth = root.clientWidth;

      videos.forEach(function (video) {
        var aspectRatio = video.clientHeight / video.clientHeight;
        video.style.width = contentWidth;
        video.style.height = contentWidth * aspectRatio;
      });
    }
  }, {
    key: 'switchTabs',
    value: function switchTabs(e) {
      var tab = e.currentTarget;
      var tabContainer = tab.parentElement;
      var tabContentContainer = tabContainer.nextElementSibling;
      var position = [].concat((0, _toConsumableArray3.default)(tabContainer.children)).indexOf(tab);
      var content = tabContentContainer.querySelector(':scope > li:nth-of-type(' + position + ')');

      tabContainer.children.forEach(function (el) {
        el.matches('li.active') && el.classList.remove('active');
      });
      tabContentContainer.children.forEach(function (el) {
        el.matches('li.active') && el.classList.remove('active');
      });

      tab.classList.add('active');
      content.classList.add('active');

      this.setupVideos(content);
    }
  }, {
    key: 'setupTabs',
    value: function setupTabs() {
      var tabs = this.el.querySelectorAll('.tabs');
      var tabsContent = this.el.querySelectorAll('.tabs-content');

      if (!tabs.length) {
        return;
      }

      if (this.el.querySelector('.tabs:first-child')) {
        this.el.parentElement.classList.add('no-border');
      }

      tabs.querySelector('li').classList.add('active');
      return tabsContent.querySelector('li').classList.add('active');
    }
  }, {
    key: 'unload',
    value: function unload() {
      this.ev.unregisterAll();
    }
  }]);
  return RTE;
}();

exports.default = RTE;